import React from 'react';
import type { CatalogDirection, CatalogService } from '../types';

interface DirectionSettingsDrawerProps {
  direction: CatalogDirection | null;
  roleCode: string;
  services: CatalogService[];
  isOpen: boolean;
  onClose: () => void;
  onAllowAll: (directionId: string) => void;
  onDenyAll: (directionId: string) => void;
  onResetPolicy: (directionId: string) => void;
}

export const DirectionSettingsDrawer: React.FC<DirectionSettingsDrawerProps> = ({
  direction,
  roleCode,
  services,
  isOpen,
  onClose,
  onAllowAll,
  onDenyAll,
  onResetPolicy,
}) => {
  if (!isOpen || !direction) return null;

  const dirServices = services.filter((s) => s.primary_direction_id === direction.direction_id);

  return (
    <div className="cov-modal-overlay" onClick={onClose}>
      <div className="cov-drawer" onClick={(e) => e.stopPropagation()}>
        <div className="cov-drawer-head">
          <div>
            <h3 style={{ margin: 0, fontSize: '1.125rem' }}>Настройка направления для роли</h3>
            <span style={{ fontSize: '0.75rem', color: '#64748b' }}>
              Роль: <strong>{roleCode}</strong> · {direction.title}
            </span>
          </div>
          <button className="cov-btn cov-btn-outline" onClick={onClose}>✕</button>
        </div>

        <div className="cov-drawer-body">
          <div style={{ background: '#131d31', padding: '1rem', borderRadius: '8px', border: '1px solid #1e293b' }}>
            <h4 style={{ margin: '0 0 0.5rem 0', fontSize: '0.875rem' }}>Оценка воздействия (Impact Preview)</h4>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.5rem', fontSize: '0.8125rem', color: '#94a3b8' }}>
              <div>Всего услуг в направлении: <strong style={{ color: '#fff' }}>{dirServices.length}</strong></div>
              <div>Влияет на новые заявки: <strong style={{ color: '#38bdf8' }}>Да</strong></div>
              <div>Исторические заявки: <strong style={{ color: '#10b981' }}>Сохраняются</strong></div>
              <div>Submitted orders workflow: <strong style={{ color: '#10b981' }}>Не блокируются</strong></div>
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
            <button
              className="cov-btn cov-btn-primary"
              style={{ justifyContent: 'center', padding: '0.75rem' }}
              onClick={() => {
                onAllowAll(direction.direction_id);
                onClose();
              }}
            >
              ✓ Разрешить все услуги направления для {roleCode}
            </button>

            <button
              className="cov-btn cov-btn-danger-outline"
              style={{ justifyContent: 'center', padding: '0.75rem' }}
              onClick={() => {
                onDenyAll(direction.direction_id);
                onClose();
              }}
            >
              ✕ Запретить всё направление для {roleCode}
            </button>

            <button
              className="cov-btn cov-btn-outline"
              style={{ justifyContent: 'center', padding: '0.75rem' }}
              onClick={() => {
                onResetPolicy(direction.direction_id);
                onClose();
              }}
            >
              ↺ Сбросить до унаследованной политики роли
            </button>
          </div>

          <div>
            <h5 style={{ margin: '1rem 0 0.5rem 0', fontSize: '0.8125rem', color: '#64748b' }}>
              Услуги направления ({dirServices.length})
            </h5>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.35rem' }}>
              {dirServices.map((s) => (
                <div
                  key={s.service_id}
                  style={{
                    padding: '0.5rem 0.75rem',
                    background: '#131d31',
                    borderRadius: '6px',
                    fontSize: '0.8125rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                  }}
                >
                  <span style={{ color: '#f59e0b', fontWeight: 600 }}>{s.display_code}</span>
                  <span>{s.title}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="cov-drawer-foot">
          <button className="cov-btn cov-btn-outline" onClick={onClose}>Закрыть</button>
        </div>
      </div>
    </div>
  );
};
